export const customerNotifications = [
    {
        id: 5,
        name: 'invalid_url'
        //CUSTOMER_NOTIFICATIONS:TYPE:INVALID_URL
    },
    {
        id: 10,
        name: 'promo_codes_exhausted'
        //CUSTOMER_NOTIFICATIONS:TYPE:PROMO_CODES_EXHAUSTED
    },
    {
        id: 11,
        name: 'missed_tag_in_segment'
        //CUSTOMER_NOTIFICATIONS:TYPE:MISSED_TAG_IN_SEGMENT_ERROR
    },
    {
        id: 12,
        name: 'request_rate_limit_achieved'
        //CUSTOMER_NOTIFICATIONS:TYPE:RATE_LIMIT_ACHIEVED
    },
    {
        id: 13,
        name: 'import_has_failed'
        //CUSTOMER_NOTIFICATIONS:TYPE:IMPORT_FAILED
    }
];

export function isCustomerNotification(notification) {
    return customerNotifications
        .map(type => type.id)
        .includes(notification.notification_type_id);
}
